import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ErrorhandlingService {

  constructor() { }

  logToConsole(object: any) {
    if (!environment.production) {
      console.log(object);
    }
  }

  log2Console(object1: any, object2: any) {
    if (!environment.production) {
      console.log(object1, object2);
    }
  }
}
